import { useEntitlements } from "~features/access";
import { handleTrackClick } from "~/lib/analytics/handleTrackClick";
import { cx } from "~utils";
import styles from "./Footer.module.css";
import footerImage from "./assets/footerProductImg.png";
import SciAmMeatballIcon from "~/assets/sciam";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TikTokIcon,
  YouTubeIcon,
  RedditIcon,
} from "./assets/svg-icons";

function handleDoNotSellMyDataClick(e) {
  handleTrackClick("site-footer-do-not-sell-my-data-21", e);
  handleDoNotSellClick(e);
}

function handleDoNotSellClick(e) {
  e.preventDefault();
  window.Optanon?.ToggleInfoDisplay();
}

function SubscribeSection() {
  return (
    <div className={styles.footerSubscribe}>
      <div className={cx(styles.footerFlexContainer, styles.footerContainer)}>
        <div className={styles.footerLinks}>
          <p className={styles.footerText}>
            Subscribe to <i>Scientific American</i> to learn and share the most exciting
            discoveries, innovations and ideas shaping our world today.
          </p>
          <a
            className={styles.footerLink}
            href="/getsciam/"
            onClick={(e) => {
              handleTrackClick("site-footer-getsciam-1", e);
            }}
          >
            Subscription Plans
          </a>
          <a
            className={styles.footerLink}
            href="/getsciam/gift/"
            onClick={(e) => {
              handleTrackClick("site-footer-gift-2", e);
            }}
          >
            Give a Gift Subscription
          </a>
        </div>
      </div>
    </div>
  );
}

function FooterLinks() {
  return (
    <footer className={styles.footer}>
      <div className={cx(styles.grid, styles.footerContainer)}>
        <div className={styles.grid__col}>
          <ul>
            <li className={styles.footerSmallLink}>
              <b>Explore SciAm</b>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/latest-issue/"
                onClick={(e) => {
                  handleTrackClick("site-footer-latest-issue-3", e);
                }}
              >
                Latest Issue
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/"
                onClick={(e) => {
                  handleTrackClick("site-footer-latest-stories-4", e);
                }}
              >
                News
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/opinion/"
                onClick={(e) => {
                  handleTrackClick("site-footer-opinion-5", e);
                }}
              >
                Opinion
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/newsletters/"
                onClick={(e) => {
                  handleTrackClick("site-footer-newsletter__signup-6", e);
                }}
              >
                Newsletters
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/podcasts/"
                onClick={(e) => {
                  handleTrackClick("site-footer-podcasts-7", e);
                }}
              >
                Podcasts
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/games/"
                onClick={(e) => {
                  handleTrackClick("site-footer-games-8", e);
                }}
              >
                Games
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/travel/"
                onClick={(e) => {
                  handleTrackClick("site-footer-travel-9", e);
                }}
              >
                Travel
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.grid__col}>
          <ul className="footer-links">
            <li className={cx(styles.footerSmallLink, styles.footerLinkHeader)}>
              <b>Company</b>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/page/about-scientific-american/"
                onClick={(e) => {
                  handleTrackClick("site-footer-about-10", e);
                }}
              >
                About
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/pressroom/"
                onClick={(e) => {
                  handleTrackClick("site-footer-press-room-11", e);
                }}
              >
                Press Room
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/page/frequently-asked-questions/subscriptions-products/"
                onClick={(e) => {
                  handleTrackClick("site-footer-faq-12", e);
                }}
              >
                FAQs
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/page/contact-us/customer-service/"
                onClick={(e) => {
                  handleTrackClick("site-footer-contact-13", e);
                }}
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/standards-and-ethics/"
                onClick={(e) => {
                  handleTrackClick("site-footer-standards-and-ethics-14", e);
                }}
              >
                Standards &amp; Ethics
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/page/international/"
                onClick={(e) => {
                  handleTrackClick("site-footer-international-edition-15", e);
                }}
              >
                International Editions
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/mediakit/"
                onClick={(e) => {
                  handleTrackClick("site-footer-advertise-16", e);
                }}
              >
                Advertise
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.grid__col}>
          <ul className="footer-links">
            <li className={cx(styles.footerSmallLink, styles.footerLinkHeader)}>
              <b>More</b>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/accessibility-statement/"
                onClick={(e) => {
                  handleTrackClick("site-footer-accessibility-statement-17", e);
                }}
              >
                Accessibility
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/page/terms-of-use/"
                onClick={(e) => {
                  handleTrackClick("site-footer-terms-18", e);
                }}
              >
                Terms of Use
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/page/privacy-policy/"
                onClick={(e) => {
                  handleTrackClick("site-footer-privacy-policy-19", e);
                }}
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/page/california-consumer-privacy-statement/"
                onClick={(e) => {
                  handleTrackClick("site-footer-california-privacy-20", e);
                }}
              >
                California Consumer Privacy Statement
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="#"
                onClick={(e) => {
                  handleDoNotSellMyDataClick(e);
                }}
              >
                Use of cookies/Do not sell my data
              </a>
            </li>
            <li>
              <a
                className={styles.footerSmallLink}
                href="/page/return-refund-policy/"
                onClick={(e) => {
                  handleTrackClick("site-footer-return-refund-22", e);
                }}
              >
                Return &amp; Refund Policy
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.footerContainer}>
        <div className={styles.footerCopyright}>
          <p>
            Scientific American is part of Springer Nature, which owns or has commercial relations
            with thousands of scientific publications (many of them can be found at
            www.springernature.com/us). Scientific American maintains a strict policy of editorial
            independence in reporting developments in science to our readers.
          </p>
          <p>
            © 2025 SCIENTIFIC AMERICAN, A DIVISION OF SPRINGER NATURE AMERICA, INC.
            <br />
            ALL RIGHTS RESERVED.
          </p>
        </div>
        <p className={styles.footerSocialMedia}>
          <span className={styles.footerLogo}>
            <SciAmMeatballIcon width="75px" height="75px" />
          </span>
          <a
            href="https://www.facebook.com/ScientificAmerican"
            target="_blank"
            alt="Facebook link"
            title="Facebook"
            onClick={(e) => {
              handleTrackClick("site-footer-facebook-23", e);
            }}
          >
            <FacebookIcon />
          </a>
          <a
            href="https://www.instagram.com/scientific_american/?hl=en"
            target="_blank"
            alt="Instagram link"
            title="Instagram"
            onClick={(e) => {
              handleTrackClick("site-footer-instagram-24", e);
            }}
          >
            <InstagramIcon />
          </a>
          <a
            href="https://www.linkedin.com/company/scientific-american"
            target="_blank"
            alt="LinkedIn link"
            title="LinkedIn"
            onClick={(e) => {
              handleTrackClick("site-footer-linkedin-25", e);
            }}
          >
            <LinkedInIcon />
          </a>
          <a
            href="https://www.tiktok.com/@scientificamerican"
            target="_blank"
            alt="TikTok link"
            title="TikTok"
            onClick={(e) => {
              handleTrackClick("site-footer-tiktok-26", e);
            }}
          >
            <TikTokIcon />
          </a>
          <a
            href="https://www.youtube.com/user/SciAmerican"
            target="_blank"
            alt="YouTube link"
            title="YouTube"
            onClick={(e) => {
              handleTrackClick("site-footer-youtube-27", e);
            }}
          >
            <YouTubeIcon />
          </a>
          <a
            href="https://www.reddit.com/r/ScientificAmerican/"
            target="_blank"
            alt="Reddit link"
            title="Reddit"
            onClick={(e) => {
              handleTrackClick("site-footer-reddit-28", e);
            }}
          >
            <RedditIcon />
          </a>
        </p>
      </div>
    </footer>
  );
}

export default function Footer() {
  return (
    <>
      <SubscribeSection />
      <FooterLinks />
    </>
  );
}
